import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Video } from '../../classes/video';
import {DomSanitizer} from '@angular/platform-browser';
import {forEach} from '@angular/router/src/utils/collection';

declare var jQuery: any;

@Component({
  selector: 'app-video-book',
  templateUrl: './video-book.component.html',
  styleUrls: ['./video-book.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class VideoBookComponent implements OnInit {

  @ViewChild('book') book;
  videos: Array<Video>;

  bookName: string;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.videos = [];
    this.route.data
      .subscribe((data: { videos: any }) => {
        data.videos['items'].forEach(element => {
          const snippet = element['snippet'];
          this.videos.push(
            new Video(snippet['resourceId']['videoId'],
              snippet['title'], snippet['description'],
              snippet['thumbnails']['standard']['url'],
              this.sanitizer)
          );
        });

        this.setupBook();
      });
  }

  setupBook() {
    const book = jQuery(this.book.nativeElement);
    jQuery(document).ready(function() {
      book.turn({
        display: 'double',
        acceleration: true,
        autoCenter: true,
        gradients: true
      });

      book.bind('start', function() {
        jQuery('iframe').css('pointer-events', 'none');
      });
      book.bind('turning', function() {
        jQuery('iframe').css('display', 'none');
        jQuery('iframe').css('opacity', '1');
      });
      book.bind('turned', function() {
        jQuery('iframe').css('display', 'inline-block');
        jQuery('iframe').css('opacity', '0');

        setTimeout(function () {
          jQuery('iframe').css('opacity', '1');
        }, 1000);
      });
      book.bind('end', function() {
        jQuery('iframe').css('pointer-events', 'auto');
      });

      setTimeout(function() {
        book.css('opacity', '1');
        setTimeout(function() {
          book.turn('page', 2);
        }, 1000);
      }, 200);

      window.addEventListener('resize', function (e) {
        const root = jQuery(':root');
        book.turn('size',
          root.css('--desktop-book-width'),
          root.css('--desktop-book-height-proportion') * parseInt(root.css('--desktop-book-width'), 10));
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/video-book/video-book.component.ts